import React from "react";
import { navigate } from "gatsby";
import { Box, ButtonBase, useMediaQuery, useTheme } from "@mui/material";

import LogoImg from "../../images/logo.svg";
import LogoIcon from "../../images/logo.svg";

interface LogoProps {
  icon?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ icon }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ButtonBase
      onClick={() => navigate("/")}
      aria-label="Navigate to home page"
    >
      <Box
        component="img"
        src={icon ? LogoIcon : LogoImg}
        width={isSmall ? `85px` : `185px`}
        alt="Crittora company logo"
      />
    </ButtonBase>
  );
};
